import React, {Component} from 'react'

export default class UserFormatter extends Component {
    render() {
        const {value} = this.props;
        return(<span>{value.firstName + " " + value.lastName}</span>);
    }
}


// WEBPACK FOOTER //
// ./src/components/grid-formatters/UserFormatter.js